export default __webpack_public_path__ + "static/roadmap-d0696c6e9bf60769b972418401f81ff1.png";